(function () {
  function initContactSections(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.sevenvn-contact-section');

    sections.forEach(function (section) {
      if (section.dataset.sevenvnContactReady === 'true') return;
      section.dataset.sevenvnContactReady = 'true';

      if (section.dataset.revealEnabled === 'true' && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            section.classList.add('is-visible');
            observer.disconnect();
          });
        }, { threshold: 0.18 });

        observer.observe(section);
      } else {
        section.classList.add('is-visible');
      }

      var form = section.querySelector('.sevenvn-contact-form');
      var submit = section.querySelector('.sevenvn-contact-submit');

      if (form && submit) {
        form.addEventListener('submit', function () {
          submit.setAttribute('aria-busy', 'true');
          submit.disabled = true;
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initContactSections(document); });
  } else {
    initContactSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initContactSections(event.target);
  });
})();
